import React from "react";
import { Button, Typography, makeStyles } from "@material-ui/core";
import Modal from "../../shared/components/Modal";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: "400px",
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    gap: theme.spacing(3),
  },
  containerClass: {
    maxWidth: "400px",
    padding: theme.spacing(3, 0),
  },
  title: {
    color: "rgba(106, 111, 115, 1)",
    font: "13px",
  },
}));

const Content = ({ text, buttonText, handleLoginIntoAccount, handleUseDifferentDetails }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography className={classes.title}>{text}</Typography>
      <Button variant="contained" color="primary" fullWidth onClick={handleLoginIntoAccount}>
        Log in to my account
      </Button>
      <Button variant="outlined" fullWidth onClick={handleUseDifferentDetails}>
        Use different {buttonText}
      </Button>
    </div>
  );
};
const AccountExistsModal = ({ title, text, buttonText, open, setOpen, setLoginModalOpen, setGuestLoginModalOpen }) => {
  const handleUseDifferentDetails = () => {
    setGuestLoginModalOpen(true);
    setOpen(false);
  };

  const handleLoginIntoAccount = () => {
    setLoginModalOpen(true);
    setOpen(false);
  };

  return (
    <>
      <Modal
        containerClass={useStyles().containerClass}
        open={open}
        setOpen={setOpen}
        title={title}
        header={
          <Content
            text={text}
            buttonText={buttonText}
            handleLoginIntoAccount={handleLoginIntoAccount}
            handleUseDifferentDetails={handleUseDifferentDetails}
          />
        }
      />
    </>
  );
};

export default AccountExistsModal;
